import React, { useEffect, useMemo, useRef, useState } from "react";

const ComposeInmail = ({ firebase, onClose, draft, onBlur }) => {
  const [toEmail, setToEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [urgent, setUrgent] = useState(false);
  const [providers, setProviders] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [draftId, setDraftId] = useState(null);
  const [saveStatus, setSaveStatus] = useState("");

  useEffect(() => {
    if (!draft) return;

    setDraftId(draft.id);
    setToEmail(draft.toEmail || "");
    setSubject(draft.subject || "");
    setMessage(draft.message || "");
    setUrgent(draft.urgent || false);
  }, [draft]);

  useEffect(() => {
    const loadProviders = async () => {
      try {
        const snap = await firebase.db
          .collection("healthCareProfessionals")
          .where("subscription", "in", ["premium", "core"])
          .get();

        const data = snap.docs.map((doc) => {
          const d = doc.data();

          return {
            id: doc.id,
            name: d.name || "",
            email: d.email || "",
            headshotURL: d.headshotURL || ""
          };
        });

        setProviders(data);
      } catch (err) {
        console.error("Provider load failed", err);
      }
    };

    loadProviders();
  }, [firebase]);

  const saveDraft = async () => {
  const hasContent =
    toEmail.trim() ||
    subject.trim() ||
    message.trim();

  if (!hasContent) {
    return;
  }

  const currentEmail =
    firebase.auth.currentUser.email;

  const draftData = {
    senderEmail: currentEmail,
    toEmail,
    subject,
    message,
    urgent,
    updatedAt: new Date()
  };

  try {
    setSaveStatus("Saving...");

    if (draftId) {
      await firebase.db
        .collection("mailDrafts")
        .doc(draftId)
        .update(draftData);
    } else {
      const docRef = await firebase.db
        .collection("mailDrafts")
        .add({
          ...draftData,
          createdAt: new Date()
        });

      setDraftId(docRef.id);
    }

    setSaveStatus("Saved");
  } catch (err) {
    console.error(err);
    setSaveStatus("Failed to save");
  }
};

const lastSavedRef = useRef("");

useEffect(() => {
  const current = JSON.stringify({
    toEmail,
    subject,
    message,
    urgent
  });

  if (current === lastSavedRef.current) {
    return;
  }

  const timer = setTimeout(async () => {
    await saveDraft();
    lastSavedRef.current = current;
  }, 2000);

  return () => clearTimeout(timer);
}, [toEmail, subject, message, urgent]);

  const filteredProviders = useMemo(() => {
    const search = toEmail.trim().toLowerCase();

    if (!search) return [];

    return providers
      .filter(
        (p) =>
          p.name.toLowerCase().includes(search) ||
          p.email.toLowerCase().includes(search)
      )
      .slice(0, 10);
  }, [toEmail, providers]);

  const clearMessageBody = () => {
    setToEmail("");
    setSubject("");
    setMessage("");
    setUrgent(false);
    setShowSuggestions(false);
  };

  const sendInmail = async () => {
    const body = message.trim();

    if (!toEmail.trim()) {
      alert("Please select a recipient.");
      return;
    }

    if (!body) {
      alert("Please enter a message.");
      return;
    }

    try {
      const currentEmail =
        firebase.auth.currentUser.email;
debugger;
      const docRef = await firebase.db.collection("inmail").add({
        userId: currentEmail,
        providerId: toEmail,
        subject,
        lastMessage: body,
        lastMessageAt: new Date(),
        unreadCountProvider: 1,
        unreadCountUser: 0,
        createdAt: new Date(),
        urgent
      });

       let conversationId = docRef.id;

                await firebase.db
                    .collection("inmail")
                    .doc(conversationId)
                    .collection("messages")
                    .add({
                        text: body,
                        senderId: currentEmail,
                        senderRole: "provider",
                        createdAt: new Date(),
                        readBy: [],
                    });

      alert("InMail sent successfully.");

      if (draftId) {
  await firebase.db
    .collection("mailDrafts")
    .doc(draftId)
    .delete();

  setDraftId(null);
}
      clearMessageBody();

      if (onClose) {
        onClose();
      }
    } catch (err) {
      console.error(err);
      alert("Unable to send message.");
    }
  };

  return (
    <div
     onBlur={onBlur}
      style={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        background: "#fff",
        overflow: "hidden"
      }}
    >
      {/* HEADER */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "15px 20px",
          borderBottom: "1px solid #e8e8e8",
          flexShrink: 0
        }}
      >
        <div
          style={{
            fontSize: "24px",
            fontWeight: 700
          }}
        >
          New InMail
        </div>

        <button
          onClick={onClose}
          style={{
            border: "none",
            background: "transparent",
            fontSize: "28px",
            cursor: "pointer",
            color: "#666"
          }}
        >
          ×
        </button>
      </div>

      {/* TO */}
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          padding: "12px 20px",
          borderBottom: "1px solid #ededed",
          flexShrink: 0
        }}
      >
        <div
          style={{
            width: "80px",
            fontWeight: 600,
            paddingTop: "10px"
          }}
        >
          To:
        </div>

        <div
          style={{
            flex: 1,
            position: "relative"
          }}
        >
          <input
            value={toEmail}
            onChange={(e) => {
              setToEmail(e.target.value);
              setShowSuggestions(true);
            }}
            onFocus={() =>
              setShowSuggestions(true)
            }
            placeholder="Recipient Email"
            style={{
              width: "100%",
              height: "40px",
              border: "1px solid #ddd",
              borderRadius: "6px",
              padding: "0 12px",
              outline: "none",
              boxSizing: "border-box"
            }}
          />

          {showSuggestions &&
            filteredProviders.length > 0 && (
              <div
                style={{
                  position: "absolute",
                  top: "45px",
                  left: 0,
                  right: 0,
                  background: "#fff",
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  boxShadow:
                    "0 4px 12px rgba(0,0,0,0.15)",
                  maxHeight: "250px",
                  overflowY: "auto",
                  zIndex: 9999,
                  width:"30%"
                }}
              >
                {filteredProviders.map(
                  (provider) => (
                    <div
                      key={provider.id}
                      onClick={() => {
                        setToEmail(
                          provider.email
                        );
                        setShowSuggestions(
                          false
                        );
                      }}
                      style={{
                        display: "flex",
                        alignItems:
                          "center",
                        gap: "12px",
                        padding:
                          "10px 12px",
                        cursor: "pointer",
                        borderBottom:
                          "1px solid #f5f5f5"
                      }}
                    >
                      {provider.headshotURL ? (
                        <img
                          src={
                            provider.headshotURL
                          }
                          alt=""
                          style={{
                            width: "40px",
                            height: "40px",
                            borderRadius:
                              "50%",
                            objectFit:
                              "cover"
                          }}
                        />
                      ) : (
                        <div
                          style={{
                            width: "40px",
                            height:
                              "40px",
                            borderRadius:
                              "50%",
                            background:
                              "#0078ff",
                            color:
                              "#fff",
                            display:
                              "flex",
                            alignItems:
                              "center",
                            justifyContent:
                              "center",
                            fontWeight:
                              600
                          }}
                        >
                          {provider.name
                            ?.charAt(0)
                            ?.toUpperCase()}
                        </div>
                      )}

                      <div>
                        <div
                          style={{
                            fontWeight:
                              600
                          }}
                        >
                          {provider.name}
                        </div>

                        <div
                          style={{
                            fontSize:
                              "12px",
                            color:
                              "#666"
                          }}
                        >
                          {provider.email}
                        </div>
                      </div>
                    </div>
                  )
                )}
              </div>
            )}
        </div>
      </div>

      {/* SUBJECT */}
<div
  style={{
    display: "flex",
    alignItems: "center",
    padding: "12px 20px",
    borderBottom: "1px solid #ededed",
    flexShrink: 0
  }}
>
  <div
    style={{
      width: "80px",
      fontWeight: 600
    }}
  >
    Subject:
  </div>

  <input
    value={subject}
    onChange={(e) => setSubject(e.target.value)}
    placeholder="Subject"
    style={{
      flex: 1,
      height: "40px",
      border: "1px solid #ddd",
      borderRadius: "6px",
      padding: "0 12px",
      outline: "none"
    }}
  />

  <button
    type="button"
    title={urgent ? "Marked as urgent" : "Mark as urgent"}
    onClick={() => setUrgent((u) => !u)}
    style={{
      marginLeft: "12px",
      width: "40px",
      height: "40px",
      borderRadius: "50%",
      border: urgent
        ? "1px solid #dc3545"
        : "1px solid #ddd",
      background: urgent ? "#dc3545" : "#fff",
      color: urgent ? "#fff" : "#dc3545",
      fontSize: "22px",
      fontWeight: "bold",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }}
  >
    !
  </button>
</div>

      {/* MESSAGE */}
      <div
        style={{
          flex: 1,
          padding: "15px 20px",
          overflow: "hidden"
        }}
      >
        <textarea
          value={message}
          onChange={(e) =>
            setMessage(e.target.value)
          }
          maxLength={100000}
          placeholder="Write your message..."
          style={{
            width: "100%",
            height: "100%",
            border: "1px solid #ddd",
            borderRadius: "6px",
            padding: "15px",
            resize: "none",
            overflowY: "auto",
            outline: "none",
            boxSizing: "border-box",
            fontSize: "15px"
          }}
        />
      </div>

      {/* FOOTER */}
      <div
        style={{
          display: "flex",
          justifyContent:
            "space-between",
          alignItems: "center",
          padding: "12px 20px",
          borderTop: "1px solid #ededed",
          flexShrink: 0
        }}
      >
        <button
          onClick={clearMessageBody}
          style={{
            background: "#3d5ef1",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            padding: "10px 20px",
            cursor: "pointer"
          }}
        >
          Clear
        </button>

<div
  style={{
    display: "flex",
    alignItems: "center",
    gap: "20px"
  }}
>
  <div style={{ color: "#666", minWidth: "120px" }}>
    {saveStatus || "Draft not saved"}
  </div>

  <div style={{ color: "#666" }}>
    {message.length}/100000 characters
  </div>
</div>

        <button
          onClick={sendInmail}
          style={{
            background: "#07a593",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            padding: "10px 25px",
            cursor: "pointer"
          }}
        >
          Send
        </button>
      </div>
    </div>
  );
};

export default ComposeInmail;